import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/{-$locale}/_public/search')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/{-$locale}/discovery', params } as any)
  },
})
